import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <div
      className='min-h-screen flex items-center justify-center px-4'
      style={{ background: 'var(--bg-base)' }}
    >
      <div
        className='max-w-3xl rounded-2xl shadow-xl p-8 w-full text-center'
        style={{ background: 'var(--bg-card)', border: '1px solid var(--border)' }}
      >
        <div className='mb-8'>
          <h1 className='text-9xl font-bold' style={{ color: 'var(--text-ghost)' }}>
            404
          </h1>
          <h2 className='text-3xl font-semibold mt-4' style={{ color: 'var(--text-primary)' }}>
            Page Not Found
          </h2>
          <p className='mt-2' style={{ color: 'var(--text-muted)' }}>
            Sorry, the page you&apos;re looking for doesn&apos;t exist or has been moved.
          </p>
        </div>

        <div className='flex flex-col sm:flex-row gap-4 justify-center'>
          <Link
            to='/dashboard'
            className='btn-primary inline-flex items-center justify-center gap-2 px-6 py-3'
          >
            <Home size={20} />
            Go to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
